import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import BlobCursor from "./components/BlobCursor";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Skills from "./components/Skills";
import Footer from "./components/Footer";
import OtherProjects from "./components/OtherProjects";
import Pawmeet from "./components/Pawmeet";
import Infosafe from "./components/Infosafe";
import Resume from "./components/Resume";
import ContactPage from "./components/ContactPage";
import Allprojects from "./components/Allprojects";
import Witness from "./components/Witness";
import OtherP from "./components/OtherP";
import SlowisFast from "./components/SlowisFast";
import Trailable from "./components/Trailable";
import Datathon from "./components/Datathon";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="relative">
        <ScrollToTop />
        <BlobCursor />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Projects />
              <OtherProjects />
              <Skills />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/projects/pawmeet" element={<Pawmeet />} />
          <Route path="/resume" element={
            <div className="min-h-screen flex flex-col">
              <Resume />
              <Footer />
            </div>
          } />
          <Route path="/contact" element={
            <div className="min-h-screen flex flex-col">
              <ContactPage />
              <Footer />
            </div>
          } />
          <Route path="/projects/infosafe" element={<Infosafe />} />
          <Route path="/all-projects" element={
            <div className="min-h-screen flex flex-col">
              <Allprojects />
              <Footer />
            </div>
          } />
          <Route path="/projects/witness" element={<Witness />} />
          <Route path="/otherp" element={<OtherP />} />
          <Route path="/projects/slowisfast" element={<SlowisFast />} />
          <Route path="/projects/trailable" element={<Trailable />} />
          <Route path="/projects/datathon" element={<Datathon />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
